var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_4720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16406C7.5 9.8271 7.76339 10.463 8.23223 10.9318C8.70107 11.4007 9.33696 11.6641 10 11.6641C10.663 11.6641 11.2989 11.4007 11.7678 10.9318C12.2366 10.463 12.5 9.8271 12.5 9.16406C12.5 8.50102 12.2366 7.86514 11.7678 7.3963C11.2989 6.92745 10.663 6.66406 10 6.66406C9.33696 6.66406 8.70107 6.92745 8.23223 7.3963C7.76339 7.86514 7.5 8.50102 7.5 9.16406Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7129 13.8806L11.177 17.4164C10.8645 17.7286 10.4409 17.904 9.99912 17.904C9.55738 17.904 9.13371 17.7286 8.8212 17.4164L5.28453 13.8806C4.35222 12.9482 3.71731 11.7603 3.46011 10.4671C3.2029 9.17394 3.33494 7.83352 3.83954 6.61536C4.34413 5.39721 5.19861 4.35604 6.29494 3.62351C7.39126 2.89098 8.68017 2.5 9.9987 2.5C11.3172 2.5 12.6061 2.89098 13.7025 3.62351C14.7988 4.35604 15.6533 5.39721 16.1579 6.61536C16.6625 7.83352 16.7945 9.17394 16.5373 10.4671C16.2801 11.7603 15.6452 12.9482 14.7129 13.8806Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_4720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.224fc67a050c40c2cec69ee5a8ab09ce.svg";
export { ForwardRef as ReactComponent };